// Простой ErrorBoundary для диагностики белых экранов.
// Класс-компонент (только в class API ловится componentDidCatch).
// Используется по требованию вокруг проблемных страниц.

import { Component } from 'react';
import { Alert, Button, Code, Stack, Text, Title } from '@mantine/core';

export class ErrorBoundary extends Component {
    constructor(props) {
        super(props);
        this.state = { error: null, info: null };
    }

    static getDerivedStateFromError(error) {
        return { error };
    }

    componentDidCatch(error, info) {
        console.error('[ErrorBoundary]', error, info);
        this.setState({ info });
    }

    reset = () => this.setState({ error: null, info: null });

    render() {
        if (this.state.error) {
            const stack =
                String(this.state.error?.stack || this.state.error || '') +
                (this.state.info?.componentStack ? '\n\n--- React stack ---\n' + this.state.info.componentStack : '');
            return (
                <Stack gap="md" p="md">
                    <Alert color="red" title="Ошибка на странице">
                        <Text size="sm" mb="xs">
                            {String(this.state.error?.message || this.state.error)}
                        </Text>
                        <Title order={6} mt="md">Stack:</Title>
                        <Code block style={{ whiteSpace: 'pre-wrap', maxHeight: 400, overflow: 'auto' }}>
                            {stack}
                        </Code>
                    </Alert>
                    <Button variant="light" onClick={this.reset} style={{ alignSelf: 'flex-start' }}>
                        Попробовать снова
                    </Button>
                </Stack>
            );
        }
        return this.props.children;
    }
}
